module.exports = __webpack_public_path__ + "static/img/tabs03.d446cbbe.png";